import { RequestStatus } from "request";

export interface OverviewState {
  campaignChanges: CampaignChange[];
  totalCampaignChangeCount: number;
  fetchCampaignChangesRequestState: RequestStatus;
}

export type CampaignChange = {
  campaignId: number;
  campaignName: string;
  field: string;
  oldValue: number | string | null;
  newValue: number | string | null;
  appTitle: string;
  appIcon: string;
  partnerName: string;
  createdAt: string;
};

export type CampaignChangesData = {
  campaignChanges: CampaignChange[];
  resultCount: number;
};

export const initialState: OverviewState = {
  campaignChanges: [],
  totalCampaignChangeCount: 0,
  fetchCampaignChangesRequestState: {
    isLoading: false,
    isSuccessful: false,
    isFailed: false,
  },
};

export function Overview(state = initialState, action: any) {
  switch (action.type) {
    case "campaign-changes-update-request-state":
      return {
        ...state,
        fetchCampaignChangesRequestState: action.requestState,
      };
    case "campaign-changes-update-state":
      return {
        ...state,
        campaignChanges: action.campaignChanges,
        totalCampaignChangeCount: action.totalCampaignChangeCount,
      };
    default:
      return state;
  }
}

export interface GraphRow {
  date: Date;
  installs: number;
  spend: number;
}

export interface Campaign extends CampaignDetails {
  status: boolean;
  isDirect: boolean;
  installs: number;
  appName: string;
  appId: string;
  clicks: number;
  spend: number;
  conversion_rate: number;
}

export interface CampaignDetails {
  id: string;
  name: string;
  iconUrl: string;
  mmp: string | null;
  playStoreUrl: string;
  countries: string[] | null;
  genders: number[] | null;
  minAge: number | null;
  maxAge: number | null;
  minApiLevel: number | null;
  maxApiLevel: number | null;
  bid: number;
  biddingType: string;
  dailyBudgetCap: number;
  clickUrl: string;
}

export interface OverviewReport {
  from: Date;
  until: Date;
  totalInstalls: number;
  totalSpend: number;
  graphRows: GraphRow[];
  campaigns: Campaign[];
}
